import SingleContactControl from './single';
import MultiContactControl from './multi';

export const SingleContact = SingleContactControl;
export const MultiContact = MultiContactControl;
